import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import { Box, Divider, Link, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { Title } from "@src/appV2/redesign/components/Title";

import { SUPPORT_TELEPHONE, SUPPORT_WEBFORM_URL } from "../ContactCBHInfo/constants";

export function SupportContactInfo() {
  return (
    <Box>
      <Title bold component="h6" variant="h6">
        Contact Support
      </Title>
      <Divider sx={{ marginY: 3 }} />
      <Stack direction="row" spacing={6} alignItems="center" flexWrap="wrap">
        <Stack direction="row" spacing={2} alignItems="center">
          <PhoneOutlinedIcon fontSize="small" />
          <Text semibold variant="body1">
            24/7 Support:
          </Text>
          <Link href={`tel:${SUPPORT_TELEPHONE}`} underline="none">
            {SUPPORT_TELEPHONE}
          </Link>
        </Stack>
        <Link href={SUPPORT_WEBFORM_URL} target="_blank" rel="noopener noreferrer" underline="none">
          Submit a Request
        </Link>
      </Stack>
    </Box>
  );
}
